import { SearchInput } from "react-admin";


export const ItasSearchAllFilter = [
  
    <SearchInput placeholder="Cerca" source="q" alwaysOn />,
  ];